import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Badge from "react-bootstrap/Badge";
const dayjs = require("dayjs");

function Payout({ id, amount, status, date }) {
  const formattedDate = dayjs(date * 1000);

  const getStatus = (status) => {
    switch (status) {
      case "paid":
        return "Pagado";

      case "pending":
        return "Pendiente";

      case "in_transit":
        return "En tránsito";
      case "canceled":
        return "Cancelado";
      case "failed":
        return "Fallido";

      default:
        return "N/A";
    }
  };

  const getBadgeVariant = (status) => {
    switch (status) {
      case "paid":
        return "success";
      case "pending":
        return "warning";
      case "in_transit":
        return "info";
      case "canceled":
        return "danger";
      case "failed":
        return "dark";

      default:
        return "secondary";
    }
  };

  return (
    <Col className="payout-element" id={id}>
      <Row>
        <Col lg={6}>${(amount / 100).toLocaleString("en-US")}</Col>
        <Col lg={3}>
          <Badge bg={getBadgeVariant(status)}>{getStatus(status)}</Badge>
        </Col>
        <Col lg={3}>{dayjs(formattedDate).format("DD-MMM-YYYY")}</Col>
      </Row>
    </Col>
  );
}

export default Payout;
